<script setup lang="ts">
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VButton from '@components/buttons/VButton/VButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VChangeHistory from '@modules/change-history/components/VChangeHistory/VChangeHistory.vue';
import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS,
} from '@modules/general-settings/submodules/table-columns-settings/constants';

import { TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT } from '../../constants';
import { usePickListAutoScroll, useTableColumnsSettings } from './composables';

const {
  columns,
  isSelectedPermanent,
  isOnlyPermanentLeft,
  isEditEnabled,
  isHistoryEnabled,
  historyList,
  currentTableKey,
  isEnabledLoading,
  isDisabledLoading,
  isSaveLoading,
  saveColumns,
  onSelection,
  onMoveAllToTarget,
} = useTableColumnsSettings();

const {
  registerColumn,
  registerList,
  onSelectionChange,
  onReorder,
} = usePickListAutoScroll();
</script>

<template>
  <div v-data-qa-auto-id="'AdminGeneralSettingsTableColumnsEditPage'">
    <VCard
      v-if="isEditEnabled"
      type="form"
      :title="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS, 'TAB_NAME')"
    >
      <VLoader :loading="isEnabledLoading && isDisabledLoading">
        <div>
          <label
            class="mb-2 block text-center text-muted-color"
          >
            {{ currentTableKey }}
          </label>
          <PPickList
            v-model="columns"
            data-key="id"
            breakpoint="800px"
            meta-key-selection
            scroll-height="22rem"
            :move-to-target-props="{
              disabled: isSelectedPermanent,
            }"
            :move-all-to-target-props="{
              disabled: isOnlyPermanentLeft,
            }"
            :pt="{
              sourceListContainer: {
                ref: registerList(0),
              },
              targetListContainer: {
                ref: registerList(1),
              },
            }"
            @update:selection="onSelection"
            @move-all-to-target="onMoveAllToTarget"
            @reorder="onReorder"
            @selection-change="onSelectionChange"
          >
            <template #sourceheader>
              {{ $getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT, 'ENABLED') }}
            </template>
            <template #targetheader>
              {{ $getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT, 'DISABLED') }}
            </template>
            <template #option="{ option }">
              <div
                :ref="registerColumn(option.id)"
                class="flex w-full justify-between gap-4"
              >
                <span>{{ $t(`${currentTableKey}.${option.name}`) }}</span>
                <i
                  v-if="option.permanent"
                  v-tooltip.top="'Permanent column'"
                  class="pi pi-question-circle text-lg text-primary"
                />
              </div>
            </template>
          </PPickList>

          <div class="mt-8 flex gap-2 max-sm:justify-center">
            <VButton
              :label="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT, 'SAVE')"
              :loading="isSaveLoading"
              @click="saveColumns"
            />
            <VBackButton
              :label="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT, 'BACK')"
              :to="{ name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME }"
            />
          </div>
        </div>
      </VLoader>
    </VCard>

    <VChangeHistory
      v-if="isHistoryEnabled"
      class="mt-4"
      :list="historyList"
    />
  </div>
</template>
